var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    transform: "translate(-.188)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.188,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.188,
    cy: 12,
    fill: "none",
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0v5h10",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 6.499 12.574)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b5b478f33252cb694f9529e5ae7f0124.svg";
export { ForwardRef as ReactComponent };